// extracted by mini-css-extract-plugin
module.exports = {"dropdownInverted":"styles-module__dropdownInverted___aMX5o"};